import { render, staticRenderFns } from "./CommonError.vue?vue&type=template&id=a0aa50c6&"
import script from "./CommonError.vue?vue&type=script&lang=js&"
export * from "./CommonError.vue?vue&type=script&lang=js&"
import style0 from "./CommonError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../sis/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports